import React from "react";
import { CareersShell } from "@/components/jobs/CareersShell";
import { JobApplicationForm } from "@/components/jobs/JobApplicationForm";

export default function CarriereSpontanee() {
  return (
    <CareersShell back={{ to: "/carrieres", label: "Toutes les offres" }}>
      <div className="grid lg:grid-cols-[1fr_440px] gap-10 items-start">
        <article data-testid="spontaneous-intro">
          <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-semibold mb-3">// Candidature spontanée</div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Aucune offre ne vous correspond ? Parlez-nous de vous.</h1>
          <p className="mt-5 text-base text-[#495057] max-w-xl">
            Nous étudions chaque candidature spontanée avec la même attention qu'une réponse à une offre : un <b>emploi</b> au sein de l'équipe PAG,
            ou un <b>mandat Business Partner</b> indépendant pour faire connaître la plateforme dans votre région.
          </p>
          <ul className="mt-6 space-y-2 text-sm text-[#495057]">
            <li>— Précisez le type de collaboration souhaité et vos secteurs de prédilection.</li>
            <li>— Joignez votre CV au format PDF ; pour un mandat Business Partner, votre SIRET est obligatoire.</li>
            <li>— Un accusé de réception vous est envoyé immédiatement, puis une réponse sous 10 jours ouvrés.</li>
          </ul>
        </article>
        <aside className="lg:sticky lg:top-6">
          <JobApplicationForm offer={{ id: "spontaneous", kind: "emploi", title: "Candidature spontanée" }} spontaneous />
        </aside>
      </div>
    </CareersShell>
  );
}
